import { restApiDP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getAll = (params) => {
  return restApiDP.post("/api/dp-plan-actual", params);
};

const getAllForCSV = (params) => {
  const excelParams = { ...params, isExcel: true, excel: true };
  return restApiDP.post("/api/dp-plan-actual", excelParams);
}

const getAllForRawCSV = params => {
    return fetch("/api/dp-plan-actual/raw-csv", {
            body: ResponseUtil.getExportParamsForPost(params),
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "x-tenant-id": user.tenantId,
                Authorization: `${user.type} ${user.accessToken}`,
                "x-module-name": "DP"
            }
        }).then(response => {
      // 202 Accepted: 비동기 export → 알림 빠른 폴링 시작
      if (response.status === 202) {
        window.dispatchEvent(new CustomEvent('export-started'));
      }
      return response;
    });
};

const dpPlanVsActual = {
  getAll,
  getAllForCSV,
  getAllForRawCSV
};

export default dpPlanVsActual;